import { createSlice } from '@reduxjs/toolkit';
import { contractorApi, membersApi, ridesApi } from '@store/rtk';
import { TableData } from '@uikit/Tables/types';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type homeSearchType = {
  searchMemberData: TableData;
  searchRideData: TableData;
  searchContractorData: TableData;
  searchSOData: TableData;
};

const weekendMap = {
  0: 'M',
  1: 'T',
  2: 'W',
  3: 'T',
  4: 'F',
  5: 'S',
  6: 'S',
};

const {
  searchMemberColumns,
  searchRideColumns,
  searchContractorColumns,
  searchSOColumns,
} = TABLE_COLUMNS;

const initialState: homeSearchType = {
  searchMemberData: {
    columns: searchMemberColumns,
    rows: [],
    size: 5,
  },
  searchRideData: {
    columns: searchRideColumns,
    rows: [],
    size: 5,
  },
  searchContractorData: {
    columns: searchContractorColumns,
    rows: [],
    size: 5,
  },
  searchSOData: {
    columns: searchSOColumns,
    rows: [],
    size: 5,
  },
};

export const homeSearchSlice = createSlice({
  name: 'homeSearch',
  initialState,
  reducers: {
    clearRidesData: (state: homeSearchType) => {
      state.searchRideData.rows = [];
    },
    clearMemberSearchData: (state: homeSearchType) => {
      state.searchMemberData.rows = [];
    },
    clearSearchSOData: (state: homeSearchType) => {
      state.searchSOData.rows = [];
    },
    clearSearchContractorData: (state: homeSearchType) => {
      state.searchContractorData.rows = [];
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      membersApi.endpoints.searchMember.matchFulfilled,
      (state, { payload }) => {
        const newItems = [
          ...payload.content.map((el) => ({
            ...el,
            fullName: el.fullName
              ? el.fullName
              : `${el.firstName}   ${el.lastName}`,
            primaryContactNumber:
              el?.primaryContactNumber?.replace(
                /(\d{3})(\d{3})(\d{4})/,
                '$1-$2-$3'
              ) || '',
          })),
        ];

        state.searchMemberData = {
          ...state.searchMemberData,
          rows:
            payload?.page === 0
              ? newItems
              : [...state.searchMemberData.rows, ...newItems],
          ...payload,

          requestTablePageChange: membersApi.endpoints.searchMember,
        };
      }
    );
    builder.addMatcher(
      ridesApi.endpoints.searchRides.matchFulfilled,
      (state, { payload }) => {
        state.searchRideData = {
          ...state.searchRideData,
          rows:
            payload?.page === 0
              ? payload.content
              : [...state.searchRideData.rows, ...payload.content],
          ...payload,
          requestTablePageChange: ridesApi.endpoints.searchRides,
        };
      }
    );
    builder.addMatcher(
      ridesApi.endpoints.searchStandingOrder.matchFulfilled,
      (state, { payload }) => {
        const newItems = [
          ...payload.content.map((el) => ({
            ...el,
            days: el.days.split(' ').map((num) => weekendMap[Number(num)]),
            id: el.rideId,
          })),
        ];

        state.searchSOData = {
          ...state.searchSOData,
          rows:
            payload?.page === 0
              ? newItems
              : [...state.searchSOData.rows, ...newItems],
          ...payload,
          requestTablePageChange: ridesApi.endpoints.searchStandingOrder,
        };
      }
    );
    builder.addMatcher(
      contractorApi.endpoints.searchContractors.matchFulfilled,
      (state, { payload }) => {
        const newItems = [
          ...payload.content.map((el) => ({
            ...el,
          })),
        ];

        state.searchContractorData = {
          ...state.searchContractorData,
          rows:
            payload?.page === 0
              ? newItems
              : [...state.searchContractorData.rows, ...newItems],
          ...payload,
          requestTablePageChange: contractorApi.endpoints.searchContractors,
        };
      }
    );
  },
});

export const selectHomePageModalSearch = (state) => state.homeSearch;
export const {
  clearRidesData,
  clearSearchSOData,
  clearMemberSearchData,
  clearSearchContractorData,
} = homeSearchSlice.actions;
export const homeSearchReducer = homeSearchSlice.reducer;
